<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マークファイル登録</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>登録可能マークファイル一覧</h1>
          <div class="block-row">
            <div>
              <div class="action-area">
                <label>件数：{{kymw1504Model.canRegistMarkFileNum}}</label>
              </div>
              <wj-flex-grid #dtg_CanRegistMarkFileList
                [itemsSource]="kymw1504Model.canRegistMarFilekList" id="dtg_CanRegistMarkFileList" [isReadOnly]="true"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
                [selectionMode]="'Row'" [tabindex]="0" (click)="eventCanRegistMarkFileList_CLICKHandler()"
                (itemsSourceChanged)="eventItemSourceChangedRegistMarkThisTimeList()">
                <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="160" [binding]="'markGroupName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nコード'" [width]="60" [binding]="'markCode'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク名'" [width]="222" [binding]="'markName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nファイル名'" [width]="100" [binding]="'markFileName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク区分'" [width]="140" [binding]="'supplyPromoteMarkDivName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク\n登録日'" [width]="110" [binding]="'registDate'">
                </wj-flex-grid-column>
              </wj-flex-grid>
            </div>

            <div class="img-wrapper">
              <img id="img_CanRegistMarkFile" [src]="kymw1504Model.canRegistMarkFileUrl">
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_RegistMarkFile"
            (click)="eventRegistMarkFile_CLICKHandler()" [tabindex]="0">登録</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>